<template>
  <div>
    <l-map
      ref="myMap"
      @ready="init()"
      :zoom="initialZoom"
      :center="initialLocation"
      :options="mapOptions"
      style="height: 100%; width: 100%"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <div v-if="renderLine">
        <div v-if="dot && !overlayAllData">
          <l-circle
            @click="
              panToLocation(path);
              $emit('dotClicked', index);
            "
            v-for="(path, index) in normalizedData"
            :key="`circle_${index}`"
            :lat-lng="path"
            :radius="20"
            :fill="true"
            :fillColor="
              strokeColors[
                path.value < lowerLimit ? 0 : path.value > upperLimit ? 2 : 1
              ]
            "
            :fillOpacity="1"
            :stroke="false"
          >
          </l-circle>
        </div>
        <div v-if="dot && overlayAllData">
          <div
            v-for="(survey, index) in profileData"
            :key="`circleSurvey_${index}`"
          >
            <l-circle
              @click="
                panToLocation(path);
                $emit('dotClicked', index);
              "
              v-for="(path, index) in survey"
              :key="`circle_${index}`"
              :lat-lng="path"
              :radius="20"
              :fill="true"
              :fillColor="
                strokeColors[
                  path.value < lowerLimit ? 0 : path.value > upperLimit ? 2 : 1
                ]
              "
              :fillOpacity="1"
              :stroke="false"
            >
            </l-circle>
          </div>
        </div>
        <div v-if="currentPosition.length > 0">
          <l-circle
            v-for="(path, index) in currentPosition"
            :key="`cp_${index}`"
            :lat-lng="path"
            :radius="30"
            :fill="true"
            :fillColor="'black'"
            :fillOpacity="0.5"
            :stroke="false"
          >
          </l-circle>
        </div>
        <div v-if="currentRange.length > 0">
          <l-circle
            v-for="(path, index) in currentRange"
            :key="`cr_${index}`"
            :lat-lng="path"
            :radius="50"
            :fill="true"
            :fillColor="'#5491f5'"
            :fillOpacity="0.5"
            :stroke="false"
          >
          </l-circle>
        </div>
        <div v-if="polyline">
          <l-polyline
            @click="returnFalse()"
            v-for="(path, index) in paths"
            :key="`line_${index}`"
            :lat-lngs="path"
            :color="
              strokeColors[
                path[0].value < lowerLimit
                  ? 0
                  : path[0].value > upperLimit
                  ? 2
                  : 1
              ]
            "
          >
          </l-polyline>
        </div>
        <!-- <div v-if="clustorMarkers != null">
          <gmap-cluster
            :gridSize="30"
            :zoomOnClick="true"
            :enableRetinaIcons="true"
            :minimumClusterSize="3"
            ref="cluster"
          >
            <gmap-marker
              :key="index"
              v-for="(m, index) in clustorMarkers"
              :position="m"
              :clickable="true"
              :draggable="true"
              @click="
                $emit('updatePos', m);
                showByIndex == index
                  ? (showByIndex = null)
                  : (showByIndex = index);
              "
              ref="marker"
            >
              <gmap-info-window :opened="showByIndex === index">
                <h6 class="q-my-none">
                  {{ m.data.name }}
                </h6>

                <div class="row">
                  <div class="col-12">
                    <span style="font-weight: bold">Upper Limit:</span>
                    {{ m.data.recordedUpperLimit }}
                  </div>
                  <div class="col-12">
                    <span style="font-weight: bold">Lower Limit:</span>
                    {{ m.data.recordedLowerLimit }}
                  </div>
                  <div class="col-12">
                    <span style="font-weight: bold">Date:</span>
                    {{ formatDate(m.data.date) }}
                  </div>
                  <div class="col-12">
                    <q-btn
                      flat
                      text
                      class="full-width"
                      @click="$emit('clustorMapMarkerClicked', m.data)"
                      >View Report</q-btn
                    >
                  </div>
                </div>
              </gmap-info-window>
            </gmap-marker>
          </gmap-cluster>
        </div> -->
      </div>
    </l-map>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import L from "leaflet";
import { LMap, LTileLayer, LCircle, LPolyline } from "vue2-leaflet";

export default {
  components: { LMap, LTileLayer, LCircle, LPolyline },
  computed: {
    ...mapGetters([]),
  },
  props: {
    mapType: String,
    options: Object,
    center: Object,
    zoom: Number,
    source: String,
    polyline: {
      type: Boolean,
      default: false,
    },
    dot: {
      type: Boolean,
      default: false,
    },
    normalizedData: {
      type: Array,
      default: null,
    },
    upperLimit: {
      type: [Number, String],
      default: 15,
    },
    lowerLimit: {
      type: [Number, String],
      default: 10,
    },
    overlayAllData: {
      type: Boolean,
      default: false,
    },
    profileData: {
      type: Array,
      default: null,
    },
    clustorMarkers: {
      type: Array,
      default: null,
    },
  },
  watch: {
    normalizedData: function () {
      this.generatePaths();
    },
    profileData: function () {
      this.generatePaths();
    },
    upperLimit: function () {
      setTimeout(() => {
        this.generatePaths();
      }, 100);
    },
    lowerLimit: function () {
      setTimeout(() => {
        this.generatePaths();
      }, 100);
    },
  },
  data: () => ({
    // Leaflet
    initialLocation: L.latLng(-42.35, 168.9),
    initialZoom: 15,
    map: null,
    mapOptions: {
      zoomSnap: 0.5,
    },
    url: "http://192.168.4.100:8081/styles/osm-bright/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

    paths: [],
    pathsList: [],
    renderLine: false,
    strokeColors: ["#008000", "#eb9c34", "#eb4034"],
    currentPosition: [],
    currentRange: [],

    // Map markers
    showByIndex: null,
    currentZoomLevel: 0,
  }),
  mounted() {
    this.generatePaths();
  },
  methods: {
    init() {
      this.map = this.$refs.myMap.mapObject;
    },
    generatePaths() {
      this.renderLine = false;
      this.paths = [];
      this.pathsList = [];
      if (this.overlayAllData) {
        this.generatePathsProfileData();
      } else {
        if (this.normalizedData != null) {
          this.generatePathsSurveyData(
            JSON.parse(JSON.stringify(this.normalizedData))
          );
        }
      }
      this.renderLine = true;
    },
    generatePathsProfileData() {
      this.profileData.forEach((scan) => {
        let selected = false;
        if (scan.id == this.selectedMergingScan) {
          selected = true;
        }
        this.generatePathsSurveyData(
          JSON.parse(JSON.stringify(scan.normalizedData)),
          selected
        );
        this.pathsList.push(JSON.parse(JSON.stringify(this.paths)));
        this.paths = [];
      });
    },
    generatePathsSurveyData(normalizedData, selected = false) {
      let currentPaths = [];
      let currentLimit = null;

      normalizedData.forEach((path) => {
        if (selected) {
          path.highlighted = true;
        }
        if (!path.hideCircle) {
          let pathLimit =
            path.value < this.lowerLimit
              ? 1
              : path.value > this.upperLimit
              ? 3
              : 2;

          if (currentLimit == pathLimit) {
            currentPaths.push(path);
          } else {
            if (currentPaths.length != 0) {
              this.paths.push(currentPaths);
              let startPath = currentPaths[currentPaths.length - 1];
              startPath.value = path.value;
              currentPaths = [startPath, path];
            } else {
              currentPaths = [path];
            }

            currentLimit = pathLimit;
          }
        }
      });
      if (currentPaths.length != 0) {
        this.paths.push(currentPaths);
      }
    },
    panToLocation(position) {
      this.map.panTo(position);
      // this.$refs.googleMaps.$mapPromise.then(map => {
      //   map.panTo({ lat: position.lat, lng: position.lng });
      // });
      this.currentPosition = [position];
    },
    drawRangePoints(min, max) {
      this.currentRange = [min, max];
    },
    // zoomToBounds(min, max) {
    //   this.$refs.googleMaps.$mapPromise.then(map => {
    //     this.$gmapApiPromiseLazy().then(() => {
    //       console.log(min, max);
    //       let bounds = new google.maps.LatLngBounds(min, max);
    //       map.fitBounds(bounds, 1);
    //     });
    //   });
    // },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    returnFalse() {
      return false;
    },
  },
};
</script>
